import { render } from "./ReservationFactory.vue?vue&type=template&id=c9b65f46&scoped=true"
import script from "./ReservationFactory.vue?vue&type=script&lang=js"
export * from "./ReservationFactory.vue?vue&type=script&lang=js"

import "./ReservationFactory.vue?vue&type=style&index=0&id=c9b65f46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9b65f46"]])

export default __exports__